import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { Button } from 'react-bootstrap';
import { SiteStatusName } from 'constants/SiteCreator';
import editIcon from '../assets/img/icons/edit-primary.svg';

function SiteCreatorTableRow({ item }) {
  const { id, serial, title, isActive } = item;

  return (
    <>
      <td>{serial}</td>
      <td>{title}</td>
      <td>{isActive ? SiteStatusName.ACTIVE : SiteStatusName.INACTIVE}</td>
      <td>
        <Button
          className="btn-icon rounded-circle btn-ghost-light"
          id={`tooltip${id}`}
          size="sm"
          type="button"
        >
          <img src={editIcon} alt="Edit icon" />
        </Button>
        <UncontrolledTooltip
          className="uncontrolled-tooltip"
          delay={0}
          target={`tooltip${id}`}
        >
          Edit
        </UncontrolledTooltip>
      </td>
    </>
  );
}

export default SiteCreatorTableRow;
